<script lang="ts">
import SponsorshipCard from '@/components/cards/SponsorshipCard.vue'
import { useSponsorshipsStore } from '@/stores/sponsorships'
import { defineComponent } from 'vue'

import AppCarousel from '../carousel/AppCarousel.vue'
import CarouselItem from '../carousel/CarouselItem.vue'

/**
 * Sponsorship Section.
 */
export default defineComponent({
  components: {
    SponsorshipCard,
    AppCarousel,
    CarouselItem,
  },
  props: {
    displayWatchButton: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const sponsorshipsStore = useSponsorshipsStore()

    return {
      sponsorshipsStore,
    }
  },
  data() {
    return {
      upgradePlan: this.$plansStore.getPlanByTier(
        'vip',
        this.$userStore.highestPlan?.period
      ),
    }
  },
  async mounted() {
    await this.sponsorshipsStore.fetchSponsors()
  },
})
</script>

<template>
  <AppSection>
    <AppCarousel
      :title="$t('section.sponsorships.heading')"
      :icon="Icons.Diversity"
    >
      <template #preamble>
        <p>{{ $t('section.sponsorships.excerpt') }}</p>
      </template>

      <CarouselItem
        v-for="(sponsorship, key) in sponsorshipsStore.sponorshipsArray"
        :key
        class="w-[306px] max-w-[100%]"
      >
        <SponsorshipCard :sponsorship :display-button="displayWatchButton" />
      </CarouselItem>
    </AppCarousel>

    <AppUpgradeModal
      v-if="
        $userStore.showUpgradePlan &&
        $userStore.highestPlan &&
        $userStore.vipPlan
      "
      :user-plan="$userStore.highestPlan"
      :upgrade-plan="$userStore.vipPlan"
    />
    <AppMembershipButton v-if="$userStore.isLoggedOut" />
  </AppSection>
</template>
